export default "/booking-panel"